import { createComponent } from '../lib';
import { VmEmbed } from '@vime/core';
import { define } from '../lib';
define('vm-embed', VmEmbed);
;
export default createComponent('vm-embed', new Set(['embedSrc', 'mediaTitle', 'params', 'origin', 'preconnections', 'decoder']));
